import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { base } from '../api-config';
import { LIMIT, SKIP } from '../constants';

import { ExamType, ExamTypeRequest } from '../models/exam-type';

const endpoint = `${base}/exam_types`;

@Injectable({
  providedIn: 'root'
})
export class ExamTypeService {

  constructor(private http: HttpClient) {}

  getAll(skip: number = SKIP, limit: number = LIMIT): Observable<ExamType[]> {
    const params = new HttpParams()
      .append('skip', skip)
      .append('limit', limit);
    return this.http.get<ExamType[]>(`${endpoint}/`, { params });
  }

  get(id: number): Observable<ExamType> {
    return this.http.get<ExamType>(`${endpoint}/${id}`);
  }

  create(unit: ExamTypeRequest): Observable<ExamType> {
    return this.http.post<ExamType>(`${endpoint}/`, unit);
  }

  update(id: number, unit: ExamTypeRequest): Observable<ExamType> {
    return this.http.put<ExamType>(`${endpoint}/${id}`, unit);
  }

  delete(id: number): Observable<string> {
    return this.http.delete<string>(`${endpoint}/${id}`);
  }
}
